import { render, staticRenderFns } from "./index.vue?vue&type=template&id=278a8fb6&scoped=true&lang=html&"
import script from "./serviceDetail.js?vue&type=script&lang=js&"
export * from "./serviceDetail.js?vue&type=script&lang=js&"
import style0 from "./serviceDetail.styl?vue&type=style&index=0&id=278a8fb6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278a8fb6",
  null
  
)

export default component.exports